import React from "react";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader } from "reactstrap";

import { capitalize } from "@helpers/general";
import { MenuWrapperAssociate } from "./MenuWrapperAssociate";
import { setIsAddPeripheralClicked } from "../../store";
import { resetDeviceStore, setEditedSelectedRows } from "../store";

type PrintersPathsModalType = {
    setIsDeviceAssociateModalOpened: Function;
    isDeviceAssociateModalOpened: boolean;
    selectedRows: any;
    isDataUpdated: boolean | number;
    setDataIsUpdated: Function;
    oneShop: boolean;
};

export function DeviceAssociateModal({
    setIsDeviceAssociateModalOpened,
    isDeviceAssociateModalOpened,
    selectedRows,
    isDataUpdated,
    setDataIsUpdated,
    oneShop,
}: PrintersPathsModalType) {
    const { t } = useTranslation();

    const applicationRows = React.useMemo(
        () =>
            (selectedRows || []).filter(
                (row: any) =>
                    row.appId !== undefined && row.Application !== ""
            ),
        [selectedRows]
    );

    const isMulti = applicationRows.length > 1;
    const titleSuffix = isMulti
        ? applicationRows
              .map((row: any) => row.Application)
              .filter(Boolean)
              .join(", ")
        : selectedRows[0]?.Application ?? "";

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                className="modal-wrapper__clz modal-assoc__clz cmn_frm_popupAssociation"
                isOpen={isDeviceAssociateModalOpened}
            >
                <ModalHeader
                    toggle={() => {
                        setIsDeviceAssociateModalOpened!(
                            !isDeviceAssociateModalOpened
                        );
                        resetDeviceStore();
                        setEditedSelectedRows([]);
                        setIsAddPeripheralClicked(false);
                    }}
                >
                    <StyledH2>
                        {capitalize(
                            `${t(
                                "Associate a device with an application"
                            )} (${titleSuffix}) `
                        )}
                    </StyledH2>
                </ModalHeader>
                <MenuWrapperAssociate
                    rowData={selectedRows}
                    setIsDeviceAssociateModalOpened={
                        setIsDeviceAssociateModalOpened
                    }
                    isDeviceAssociateModalOpened={isDeviceAssociateModalOpened}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={isDataUpdated}
                    oneShop={oneShop}
                />
            </Modal>
        </React.Fragment>
    );
}
